import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

import {
  SalesOrderStatusConstant,
  ESalesOrderSource,
} from '@app/core/_constant/sales-orders.constants';
import { SalesService } from '@app/core/sales/services/sales.service';
import {
  SalesOrder,
  ShippingStatus,
} from '@app/core/sales/store/sales-order.model';
import { EFeatureFlag } from '@app/feature-toggle-list';
import { FeatureToggleService } from '@app/shared/services/feature-toggle.service';
import { EIntegrationTypes } from 'v2/modules/channel/contants/channel.constant';

import { ISalesOrder } from '../../../../v2/modules/order/interfaces/order.interface';
import { OrderUtilService } from '../../../../v2/modules/shared/services/util/order-util.service';

@Component({
  selector: 'cnc-ship-orders',
  templateUrl: './ship-orders.component.html',
  styleUrls: ['./ship-orders.component.scss'],
})
export class ShipOrdersComponent implements OnInit {
  pageTitle :string = 'Ship Orders from Client Invoices';
  @Input() salesOrders :SalesOrder[] = [];
  forShippingOrders :SalesOrder[] = [];
  cantBeShippedOrders :SalesOrder[] = [];
  shippedOrdersIssue :any[] = [];
  loading :boolean;
  shippingStatus = ShippingStatus;
  hasUpdates :boolean = false;

  constructor(
    public activeModal :NgbActiveModal,
    private salesSvc :SalesService,
    private toastr :ToastrService,
    private cd :ChangeDetectorRef,
    private featureToggleService :FeatureToggleService,
    private orderUtilService :OrderUtilService,
  ) {}

  ngOnInit() :void {
    this.salesOrders.forEach((order :any) => {
      const salesOrder :ISalesOrder = {
        ...order,
        channel: order.channelRelation,
        channelId: order.channel_id,
        isPosted: order.is_posted,
        orderItems: order.order_items,
      };
      const orderShippabilityErrors =
        this.orderUtilService.checkOrderShippabilityErrors(salesOrder);
      let canShip :boolean = true;
      if (orderShippabilityErrors.isNotShippable) {
        canShip = false;
      }
      if (canShip) {
        this.forShippingOrders.push(order);
      } else {
        order.errors = [];
        if (orderShippabilityErrors.missingBillingDetails) {
          order.errors.push('No Billing Details found');
        }
        if (orderShippabilityErrors.missingShippingDetails) {
          order.errors.push('No Shipping Details found');
        }
        if (orderShippabilityErrors.isCancelledOrder) {
          order.errors.push('Order status is CANCELLED');
        }
        if (orderShippabilityErrors.hasShipstationOrderId) {
          order.errors.push('Already Pushed Order');
        }
        if (orderShippabilityErrors.isShipstation) {
          order.errors.push('Order is from Shipstation');
        }
        if (orderShippabilityErrors.isNotPosted) {
          order.errors.push('Order is not posted');
        }
        if (
          this.fgEdiIntegrationEnabled &&
          order?.channelRelation?.push_order_integration_mapping
            ?.integration_type === EIntegrationTypes.PUSH_ORDERS
        ) {
          this.forShippingOrders.push(order);
        } else {
          this.cantBeShippedOrders.push(order);
        }
      }
    });
  }

  shipOrders() {
    this.loading = true;
    this.forShippingOrders
      .filter((row :SalesOrder) => row.shippingStatus !== ShippingStatus.SHIPPED)
      .forEach((salesOrder :SalesOrder) => {
        salesOrder.shippingStatus = ShippingStatus.SHIPPING;
        this.salesSvc.shipOrderToShipstation(salesOrder.id).subscribe(
          (resp :any) => {
            salesOrder.shippingStatus = ShippingStatus.SHIPPED;
            this.hasUpdates = true;
            this.isFinished();
          },
          (errorResp :any) => {
            salesOrder.shippingStatus = ShippingStatus.FAILED;
            if (errorResp && errorResp.error) {
              salesOrder.shippingError = errorResp.error.error;
            }
            this.isFinished();
          },
        );
      });
  }

  close() {
    this.activeModal.close(this.hasUpdates);
  }

  private isFinished() {
    this.loading =
      this.forShippingOrders.filter(
        (row :SalesOrder) => row.shippingStatus === ShippingStatus.SHIPPING,
      ).length > 0;
    if (!this.loading) {
      Swal.fire('', 'Pushing orders finished.', 'info');
      this.cd.detectChanges();
    }
  }

  get fgEdiIntegrationEnabled() :boolean {
    return this.featureToggleService.featureEnabled(EFeatureFlag.EDI_INTEGRATION);
  }
}
